import LoadGame from "@core/Scenes/LoadGame";
import BaseRoulette_Images from 'BaseRoulette/Assets/Graphics/**/*.png';
import BaseRoulette_Json from 'BaseRoulette/Assets/**/*.json';
import BaseRoulette_Xml from 'BaseRoulette/Assets/**/*.xml';
import BaseRoulette_MP3 from 'BaseRoulette/Assets/Audio/*.mp3';
import BaseRoulette_M4A from 'BaseRoulette/Assets/Audio/*.m4a';
import BaseRoulette_JSScripts from 'BaseRoulette/Assets/Plugins/*.js'
import { BaseRouletteMainScene } from './BaseRouletteMainScene';
import { Constants } from "@core/Utils/Constants";
import { CrazyMegaEpicScalingStructure, GetScalingInfo } from "@core/Utils/HelperFunction";
import { Client } from "@core/Client";

export class BaseRouletteLoadGame extends LoadGame {
	constructor() {
		super();
	}

	create(): void {
		this.scale.fullscreenTarget = document.getElementById("game");
		this.resize(GetScalingInfo());

		this.destroyAndContinue(true);
	}

	override LoadGraphics() {
		super.LoadGraphics();
	}

	override LoadSounds(): void {
		super.LoadSounds();

		this.load.audio(Constants.SOUNDS.BET_CLEAR_ALL, [BaseRoulette_MP3.bet_clear_all, BaseRoulette_M4A.bet_clear_all]);
		this.load.audio(Constants.SOUNDS.BET_PLACE_GROUP, [BaseRoulette_MP3.bet_place_group, BaseRoulette_M4A.bet_place_group]);
		this.load.audio(Constants.SOUNDS.BET_REPEAT, [BaseRoulette_MP3.bet_repeat, BaseRoulette_M4A.bet_repeat]);
		this.load.audio(Constants.SOUNDS.VIEW_CHANGE, [BaseRoulette_MP3.view_change, BaseRoulette_M4A.view_change]);
		this.load.audio(Constants.SOUNDS.SLIDER_CHANGE, [BaseRoulette_MP3.selection, BaseRoulette_M4A.selection]);
		this.load.audio(Constants.SOUNDS.BETS_CLOSED, [BaseRoulette_MP3.bets_close, BaseRoulette_M4A.bets_close]);
		this.load.audio(Constants.SOUNDS.MENU_SELECT, [BaseRoulette_MP3.menu_select, BaseRoulette_M4A.menu_select]);
		this.load.audio(Constants.SOUNDS.MENU_VALIDATE, [BaseRoulette_MP3.menu_validate, BaseRoulette_M4A.menu_validate]);

		this.load.audio(Constants.SOUNDS.DEFAULT_BACKGROUND_MUSIC, [BaseRoulette_MP3.background_music_2, BaseRoulette_M4A.background_music_2]);
		this.load.audio(Constants.SOUNDS.ALTERNATIVE_BACKGROUND_MUSIC, [BaseRoulette_MP3.background_music, BaseRoulette_M4A.background_music]);
		this.load.audio(Constants.SOUNDS.INTRO_TO_BACKGROUND_MUSIC, [BaseRoulette_MP3.intro, BaseRoulette_M4A.intro]);
	}

	override LoadPlugins(): void {
		super.LoadPlugins();

		this.load.plugin("ninepatchplugin", BaseRoulette_JSScripts.ninepatchplugin, true);
		this.load.plugin("sliderplugin", BaseRoulette_JSScripts.sliderplugin, true);
	}

	override resize(scaling: CrazyMegaEpicScalingStructure): void {
		super.resize(scaling);
	}

	protected continueToNextScene(): void {
		this.scene.add(Constants.MAIN_SCENE.CLASS_NAME, BaseRouletteMainScene, true);
		this.scene.remove(this);
	}

	private destroyAndContinue(skipClickSound: boolean = false): void {
		this.registry.set("is_game_muted", false);
		this.continueToNextScene();
	}
}

export default BaseRouletteLoadGame
